import React from 'react';

export const Stats = ({ total, remaining, memorized, studyTime }) => {
  return (
    <div className="stats">
      <div className="stat">
        <span>Total:</span>
        <span className="stat-value">{total}</span>
      </div>
      <div className="stat">
        <span>Left:</span>
        <span className="stat-value">{remaining}</span>
      </div>
      <div className="stat">
        <span>Done:</span>
        <span className="stat-value">{memorized}</span>
      </div>
      {studyTime && (
        <div className="stat">
          <span>⏱️</span>
          <span className="stat-value">{studyTime}</span>
        </div>
      )}
    </div>
  );
};
